import { render, staticRenderFns } from "./SmsSendingDashboardView.vue?vue&type=template&id=38258cc1&scoped=true"
import script from "./SmsSendingDashboardView.vue?vue&type=script&lang=js"
export * from "./SmsSendingDashboardView.vue?vue&type=script&lang=js"
import style0 from "./SmsSendingDashboardView.vue?vue&type=style&index=0&id=38258cc1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38258cc1",
  null
  
)

export default component.exports